export class List {
    listId: string
    boardId: string
    label: string
    position: number
    cards: any[]
    token: string
}
